export enum BudgetRecapVariant {
    UNDER_BUDGET = 'underBudget',
    ALMOST_OVERSPENDING = 'almostOverspending',
    OVERSPENDING = 'overspending'
}
